<!-- Shown only for the moment it takes to keep the code and move on to the
     Subscribe page; see PromoPage. -->
<cs-content></cs-content>
